module.exports = __webpack_public_path__ + "img/ubu.d7030da1.png";